import IELTSListeningIcon from "@/components/icons/IELTSListeningIcon.tsx";
import IELTSReadingIcon from "@/components/icons/IELTSReadingIcon.tsx";
import IELTSWritingIcon from "@/components/icons/IELTSWritingIcon.tsx";
import SpeakingIcon from "@/components/icons/SpeakingIcon.tsx";
import MaterialOptionItem from "@/components/materials/OptionItem.tsx";
import { cn } from "@edusogno/lib/utils";
import FolderIcon from "@/components/icons/FolderIcon.tsx";
// import pdf from "@/assets/files/IELTSFAQ2.pdf";
import pdfV2 from "@/assets/files/Guide - Frequently asked questions ENG.pdf";
import MaterialDownloadIcon from "@/components/icons/MaterialDownloadIcon.tsx";
import Button from "@edusogno/primitives/button";
import { downloadLocalFile } from "@/utils/download.ts";
import { useTranslation } from "react-i18next";
import { useMemo, useRef } from "react";
import { getMaterialOptions, isIeltsPartOfCourseStructure } from "@/utils/materials";
import { useMe, useNotifications, useUserEventsAndMaterials } from "@/data/user";
import NoItem from "@/components/NoItem";
import { MaterialOptionProps, Payment } from "@/types";
import { updateHasNewProperty } from "@/utils/notifications";

// eslint-disable-next-line react-refresh/only-export-components
export const materialOptions: MaterialOptionProps[] = [
  {
    path: "Speaking",
    label: "Speaking",
    description: "materials.speaking",
    hasNew: false,
  },
  {
    path: "IELTS",
    label: "IELTS",
    description: "materials.ielts",
    hasNew: false,
  },
  {
    path: "Grammar",
    label: "Grammar",
    description: "materials.grammar",
    hasNew: false,
  },
];

interface IELTSOptionProps {
  icon: JSX.Element;
  label: string;
  path: number;
  type: string;
}

/* eslint-disable react-refresh/only-export-components */
export const ieltsOptions: IELTSOptionProps[] = [
  {
    icon: <IELTSWritingIcon className={"w-8 h-8 fill-brand-secondary"} />,
    path: 0,
    type: "ielts writing",
    label: "IELTS Writing",
  },
  {
    icon: <IELTSListeningIcon className={"w-8 h-8 fill-brand-secondary"} />,
    path: 1,
    type: "ielts listening",
    label: "IELTS Listening",
  },
  {
    icon: <IELTSReadingIcon className={"w-8 h-8 fill-brand-secondary"} />,
    path: 2,
    type: "ielts reading",
    label: "IELTS Reading",
  },
  {
    icon: <SpeakingIcon className={"w-8 h-8 fill-brand-secondary"} />,
    path: 3,
    type: "ielts speaking",
    label: "IELTS Speaking",
  },
];

export default function Materials() {
  const { me } = useMe();

  const { eventMaterials } = useUserEventsAndMaterials();
  const materials = eventMaterials?.item?.materials;
  const materialsOptions = getMaterialOptions(materials)
  const { notifications } = useNotifications();

  const updatedMaterials = useMemo(() => {
    return updateHasNewProperty(notifications?.items || [], materials || [], materialsOptions);
  }, [materials, materialsOptions, notifications?.items]);


  const paymentOptionsRef = useRef<Payment[] | undefined>();
  const { t } = useTranslation();

  paymentOptionsRef.current = me && me?.item.user?.payments;

  const hasIelts =
    paymentOptionsRef.current &&
    isIeltsPartOfCourseStructure(paymentOptionsRef.current);

  return (
    <div className={"flex flex-col h-full gap-4 lg:mt-4"}>
      <ul className="flex flex-col gap-4 lg:flex-row">
        {updatedMaterials && updatedMaterials.length > 0 ? updatedMaterials?.map((r) => (
          <MaterialOptionItem
            key={r.label}
            description={t(r.description)}
            type={r.label}
            path={`list/${r.label}`}
            hasNew={r.hasNew}
          />
        )) : <NoItem text={t("materials.not_available", { defaultValue: "No materials available!" })} />}
      </ul>

      {hasIelts && (
        <div
          className={cn(
            "rounded-md p-4 h-[100px] flex flex-row gap-5  bg-[--primary300] w-full items-center",
          )}
        >
          <FolderIcon
            className={"mx-1 w-10 h-auto text-[--primary] fill-edu-active"}
          />
          <p className="text-base text-[--secondary] font-semibold">
            {t("materials.faq")}
          </p>
          <Button
            // onClick={() => downloadLocalFile(pdf, "IELTS FAQ.pdf")}
            onClick={() => downloadLocalFile(pdfV2, "IELTS FAQ.pdf")}
            variant={"ghost"}
            className={"w-fit ml-auto lg:hidden"}
          >
            <MaterialDownloadIcon
              className={"stroke-brand-secondary w-6 h-auto"}
            />
          </Button>
          <Button
            onClick={() => downloadLocalFile(pdfV2, "IELTS FAQ.pdf")}
            variant={"outlined"}
            color={"primary"}
            size={"md"}
            className={"ml-auto hidden lg:block bg-white"}
          >
            {t("materials.download_faq")}
          </Button>
        </div>
      )}
    </div>
  );
}
